import {
    getAlternatePremiumCalculation,
    getCustomerIdValue,
    getEnableDownloadQuote,
    getIsApiPending,
    getQuoteForm,
} from '../../../selectors/travelUg/quote';
import {
    apiTransitionShareQuoteForm,
    shareQuoteSuccess,
    shareQuoteFailure,
    setShareEmailBase64Value,
    submitTravelUgQuoteFormData,
} from '../../../actions/travelUg/quote';
import { getAccessToken } from '../../../selectors/travelUg/payments';
import axios from 'axios';
import { getAgentForm } from '../../../selectors/travelUg/travelAgentModal';
import benefitsData from '../../../../site-builder/src/applications/travelUg/GetQuote/benefits.json';
import { COVER_PLANS } from '@om/redux/actions/travelUg/types';

export const shareQuoteService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionShareQuoteForm.pending());
            try {
                const customerId = getCustomerIdValue(store.getState());

                if (!customerId.value) {
                    await store.dispatch(submitTravelUgQuoteFormData());
                }

                const resp = await share(store.getState());
                store.dispatch(shareQuoteSuccess(resp.data));

                const enableDownloadQuote = getEnableDownloadQuote(store.getState());

                if (enableDownloadQuote) {
                    store.dispatch(setShareEmailBase64Value(resp.data.base64));
                }

                store.dispatch(apiTransitionShareQuoteForm.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionShareQuoteForm.failure());
                store.dispatch(shareQuoteFailure(e));
            }
        }
    })();
    return next(action);
};

const getSelectedCoverBenefits = (selectedCoverValue) => {
    if (typeof selectedCoverValue !== 'string') return [];

    const product = benefitsData.find((p) => p.product === selectedCoverValue);

    return product ? product.benefits : [];
};

const getAlternateCover = (cover) => {
    const alternateCoverMap = {
        'Schengen Essential': 'Schengen Elite',
        'Schengen Elite': 'Schengen Essential',
        'Worldwide Essential': 'Worldwide Elite',
        'Worldwide Elite': 'Worldwide Essential',
    };

    return alternateCoverMap[cover] || '';
};

const shareQuotePayload = (state) => {
    const quotation = getQuoteForm(state);
    const customerId = getCustomerIdValue(state);
    const agent = getAgentForm(state);
    const benefits = getSelectedCoverBenefits(quotation.selectedCover.value);

    let payload = {};

    if (
        quotation.selectedCover.value.includes(COVER_PLANS.WORLDWIDE_COVER.title) ||
        quotation.selectedCover.value.includes(COVER_PLANS.SCHENGEN_COVER.title)
    ) {
        const alternateCoverValue = getAlternateCover(quotation.selectedCover.value);
        const alternatePremiumCalc = getAlternatePremiumCalculation(state);

        payload = {
            id: customerId.value,
            agentType: agent.intermediaryType?.value || '',
            email: quotation.shareEmail.value || '',
            benefits,
            alternateCover: alternateCoverValue,
            alternateBenefits: getSelectedCoverBenefits(alternateCoverValue),
            alternatePremium: alternatePremiumCalc?.value?.totalPremium,
        };
    } else {
        payload = {
            id: customerId.value,
            agentType: agent.intermediaryType?.value || '',
            email: quotation.shareEmail.value || '',
            benefits,
        };
    }

    return {
        ...payload,
    };
};

const share = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ug/share-quote';
        return await axios.post(url, shareQuotePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
